var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"link-external"},[_c('a',{attrs:{"target":"_blank","href":_vm.href}},[_vm._t("default")],2),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":"external-link-alt","size":"xs"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }